import type { Strong } from 'mdast';

import type { State } from '../state';

export function strong(state: State, node: Strong): void {
	if (!state.schema.marks.strong) {
		// Gracefully degrade: render children as plain text when schema has no strong mark
		state.parseTokens(node.children);
		return;
	}
	const mark = state.schema.marks.strong.create();
	state.openMark(mark);
	state.parseTokens(node.children);
	state.closeMark(mark);
}
